import { useEffect, useState, useCallback } from "react";
import CustomerBalanceView from "./CustomerBalanceView.js";
import CustomerCreditLogsTable from "./CustomerCreditLogsView.js";
import api from "../../services/api.js";

export default function CustomerCreditLogsVieww({ cust_id, token }) {
  const [balance, setBalance] = useState(0);
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const limit = 20; // Sesuai contoh

  const fetchCredits = useCallback(
    async (page = 1) => {
      if (!token || !cust_id) {
        console.warn("Token atau cust_id kosong", { token, cust_id });
        return;
      }

      setLoading(true);
      try {
        console.log("Fetch untuk UserID:", cust_id, "Page:", page);

        const response = await api.get("/customer-credits", {
          params: {
            userid: cust_id, // Menggunakan cust_id sebagai userid, sesuai kode asli
            page,
            limit,
          },
          headers: {
            Authorization: token, // Sesuai contoh: {Authorization : token}
          },
        });

        console.log("Response:", response.data);

        const result = response.data;
        if (result?.success) {
          setBalance(result.meta?.balance || 0);
          setLogs(Array.isArray(result.data) ? result.data : []);
          setTotalPages(result.meta?.totalPages || 1);
          setTotalItems(result.meta?.total || 0);
          setCurrentPage(result.meta?.page || 1);
        } else {
          console.error("Response tidak sukses:", result?.message);
          setLogs([]);
          setBalance(0);
        }
      } catch (err) {
        console.error("Error Detail:", {
          message: err.message,
          status: err.response?.status,
          data: err.response?.data,
          config: err.config,
        });
        // Reset state pada error
        setLogs([]);
        setBalance(0);
        setTotalPages(1);
        setTotalItems(0);
      } finally {
        setLoading(false);
      }
    },
    [cust_id, token]
  );

  useEffect(() => {
    fetchCredits(currentPage);
  }, [fetchCredits, currentPage]);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  return (
    <>
      {/* HEADER SECTION */}
      <div className="flex items-center gap-2 mb-4">
        <div className="w-1.5 h-5 bg-orange-500 rounded-full"></div>
        <h2 className="text-xl font-bold dark:text-white">Credit</h2>
      </div>

      <div className="space-y-4">
        <CustomerBalanceView balance={balance} loading={loading} />
        <CustomerCreditLogsTable
          logs={logs}
          loading={loading}
          currentPage={currentPage}
          totalPages={totalPages}
          totalItems={totalItems}
          onPageChange={handlePageChange}
        />
      </div>
    </>
  );
}
